import {Router} from '@angular/router';

/**
 * Shared navigation mapping used by both the References panel (reference-table.component.ts,
 * whose items carry legacy camelCase `typeOf` values like 'vocabEntries') and global search
 * (whose results carry the backend's SearchResultType enum values like 'VOCAB_ENTRY').
 *
 * Returns false if the type isn't recognized, so callers can show a fallback message.
 */
export function navigateToSearchResult(router: Router, typeOf: string, id: number): boolean {
  switch (typeOf) {
    case 'vocabCategories':
    case 'VOCAB_CATEGORY':
      router.navigate(['/wortschatz'], {queryParams: {c_id: id}});
      return true;

    case 'vocabEntries':
    case 'VOCAB_ENTRY':
      router.navigate(['/wortschatz'], {queryParams: {id}});
      return true;

    case 'functionalGrammarCategories':
    case 'FUNCTIONAL_GRAMMAR_CATEGORY':
      router.navigate(['/grammatik'], {queryParams: {c_id: id, type: 'func'}});
      return true;

    case 'functionalGrammarEntries':
    case 'FUNCTIONAL_GRAMMAR_ENTRY':
      router.navigate(['/grammatik'], {queryParams: {id, type: 'func'}});
      return true;

    case 'systemicGrammarCategories':
    case 'SYSTEMIC_GRAMMAR_CATEGORY':
      router.navigate(['/grammatik'], {queryParams: {c_id: id, type: 'sys'}});
      return true;

    case 'systemicGrammarEntries':
    case 'SYSTEMIC_GRAMMAR_ENTRY':
      router.navigate(['/grammatik'], {queryParams: {id, type: 'sys'}});
      return true;

    case 'textPatterns':
    case 'TEXT_PATTERN':
      router.navigate(['/textmuster', id]);
      return true;

    case 'textTypes':
    case 'TEXT_TYPE':
      router.navigate(['/textsorten'], {queryParams: {id}});
      return true;

    case 'detailedCanDoStatementCategories':
    case 'DETAILED_CDS_CATEGORY':
      router.navigate(['/kannbeschreibungen'], {queryParams: {c_id: id, flavor: 'detailed'}});
      return true;

    case 'detailedCanDoStatementEntries':
    case 'DETAILED_CDS_ENTRY':
      router.navigate(['/kannbeschreibungen'], {queryParams: {id, flavor: 'detailed'}});
      return true;

    case 'globalCanDoStatementCategories':
    case 'GLOBAL_CDS_CATEGORY':
      router.navigate(['/kannbeschreibungen'], {queryParams: {c_id: id, flavor: 'global'}});
      return true;

    case 'globalCanDoStatementEntries':
    case 'GLOBAL_CDS_ENTRY':
      router.navigate(['/kannbeschreibungen'], {queryParams: {id, flavor: 'global'}});
      return true;

    case 'verbalActionCategories':
    case 'VERBAL_ACTION_CATEGORY':
      // fix: previously navigated to /verbal/action/category/:id, a route that doesn't
      // exist in app-routing.module.ts (only /sprachhandlungen is registered) - dead link
      router.navigate(['/sprachhandlungen'], {queryParams: {c_id: id}});
      return true;

    case 'verbalActionEntries':
    case 'VERBAL_ACTION_ENTRY':
      // fix: previously navigated to /verbal/action/entry/:id (dead route)
      router.navigate(['/sprachhandlungen'], {queryParams: {id}});
      return true;

    default:
      return false;
  }
}
